"use client";

import { cn } from "@/lib/utils";

type SectionAccent = "indigo" | "violet" | "sky" | "amber";

const accentSolid: Record<SectionAccent, string> = {
  indigo: "#6366f1",
  violet: "#8b5cf6",
  sky:    "#0ea5e9",
  amber:  "#f59e0b",
};

const accentText: Record<SectionAccent, string> = {
  indigo: "#818cf8",
  violet: "#a78bfa",
  sky:    "#38bdf8",
  amber:  "#fbbf24",
};

interface ComposeSectionProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
  accent?: SectionAccent;
  compact?: boolean;
}

export function ComposeSection({
  label,
  children,
  className,
  accent,
  compact = false,
}: ComposeSectionProps) {
  const solid = accent ? accentSolid[accent] : null;
  const text  = accent ? accentText[accent]  : null;

  return (
    <div
      className={cn(
        compact ? "px-2 pb-1.5 pt-2 sm:px-2.5" : "px-3 pb-3 pt-4 sm:px-4 sm:pt-5",
        className
      )}
    >
      {label && (
        <div className="mb-2">
          <span
            className="inline-flex items-center gap-1.5 rounded-full px-2 py-[3px] text-[9px] font-semibold uppercase tracking-[0.16em]"
            style={
              solid
                ? {
                    background: `linear-gradient(135deg, ${solid}18 0%, ${solid}08 100%)`,
                    border: `1px solid ${solid}28`,
                    color: text!,
                    boxShadow: `inset 0 1px 0 rgba(255,255,255,0.55), 0 1px 4px ${solid}14`,
                  }
                : {
                    background: "rgba(203,213,225,0.18)",
                    border: "1px solid rgba(203,213,225,0.35)",
                    color: "rgb(148,163,184)",
                  }
            }
          >
            {solid && (
              <span
                className="h-1 w-1 flex-shrink-0 rounded-full"
                style={{ background: solid }}
              />
            )}
            {label}
          </span>
        </div>
      )}
      {children}
    </div>
  );
}
